import { RootState } from '../../redux/store';
import { getDesignerSlice } from '../designerSelectors';
import { clipboardSlice } from './clipboardSlice';

/**
 * Returns the entire designer clipboard slice
 */
export const getClipboard = (state: RootState) => getDesignerSlice(state)[clipboardSlice.name];
